import type { TrackerDestination, TrackingDestinationPreset } from './_types';

export const TRACKER_IDS: Record<TrackerDestination | 'dev', string> = {
  clarity: 'clarityTracker',
  sentry: 'sentryTracker',
  rudderstack: 'rudderstackTracker',
  datadog: 'datadogTracker',
  googleAnalytics: 'googleAnalyticsTracker',
  metaPixel: 'metaPixelTracker',
  launchDarkly: 'launchDarklyTracker',
  dev: 'devTracker',
} as const;

// `launchDarkly` is deliberately absent from every preset. Tracker.track falls
// back to the `analytics` preset when no options are passed, so listing it here
// would send every app event to LaunchDarkly and corrupt experiment metrics. It
// is reachable only via an explicit `{ whitelist: ['launchDarkly'] }`.
export const DESTINATION_PRESETS: Record<
  TrackingDestinationPreset,
  readonly TrackerDestination[]
> = {
  all: ['clarity', 'sentry', 'rudderstack', 'datadog', 'googleAnalytics'],
  analytics: ['clarity', 'rudderstack', 'googleAnalytics'],
};

export const BOOK_APPOINTMENT_EVENT = 'book_appointment';
